import { ExecutionResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import { DocumentNode } from 'graphql';
import produce from 'immer';

import {
  GetManualNotificationsDocument,
  ManualNotificationsItemsList,
  QueryGetManualNotificationItemsArgs,
} from 'api';

interface IReducer {
  cache: DataProxy;
  result: ExecutionResult['data'];
  query: DocumentNode;
  variables: QueryGetManualNotificationItemsArgs;
}

export default (options: IReducer) => {
  const { cache, result, query, variables } = options;
  const { getManualNotificationItems } = cache.readQuery({
    query,
    variables,
  });

  if (!getManualNotificationItems) {
    return;
  }

  const { createManualNotification } = result.data;
  const nextState = produce(
    getManualNotificationItems,
    (draftState: ManualNotificationsItemsList) => {
      draftState.count++;
      draftState.items.splice(0, 0, createManualNotification);
    },
  );

  cache.writeQuery({
    query: GetManualNotificationsDocument,
    variables,
    data: {
      getManualNotificationItems: { ...nextState },
    },
  });
};
